import { CommonModule } from '@angular/common';
import { Component, OnInit, effect } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuLinks, SettingsModel } from '../../models/settings.module';
import { environment } from '../../../environments/environment';
import { AppService } from '../../services/app.service';
import { SettingsService } from '../../services/settings.service';
import { appSettings } from '../../app.settings';

@Component({
    selector: 'app-menu',
    imports: [CommonModule, RouterModule],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit {
  isMobile = false;
  isTablet = false;
  visible: boolean = false;
  settingsModel = appSettings();

  menuLinks: MenuLinks[] = [];

  contactLinks: string[] = [];

  imgFxDomain = environment.imgFxDomain;

  constructor(
    private appService: AppService,
    private settingsService: SettingsService,
  ) {
    effect(() => {
      this.isMobile = this.settingsService.getMobileStatus();
    });
  }

  ngOnInit() {
    this.isMobile = this.settingsService.isMobile();
    this.isTablet = this.settingsService.isTablet();

    this.appService.currentheaderMenuOpen.subscribe((x) => {
      this.visible = x;
    });

    this.getLinks();

    this.contactLinks.push('Om oss:om-oss');
    this.contactLinks.push('Kontakt oss:kontakt-oss');
    this.contactLinks.push('Bærekraft:baerekraft');
  }

  getLinks() {
    if (this.settingsModel().MenuLinks) {
      this.menuLinks = this.settingsModel().MenuLinks;
    }
  }

  closeMenu() {
    this.appService.toggleMenuOpen(false);
    document.querySelector('body')?.classList.remove('header-open');

    document.querySelectorAll('.main-category').forEach((el) => {
      el.classList.remove('show');
    });

    document.querySelectorAll('.sub-category-wrapper').forEach((el) => {
      el.classList.remove('show');
    });
  }

  toggleMenu() {
    if (!this.visible) {
      document.querySelector('body')?.classList.add('header-open');
      this.initScrollTriggers();
    } else {
      document.querySelector('body')?.classList.remove('header-open');
    }
    this.appService.toggleMenuOpen(!this.visible);
  }

  mainHover(index: number) {
    if (this.visible) {
      document.querySelectorAll('.main-category').forEach((el) => {
        el.classList.remove('show');
      });
      document.querySelector('#main-category-' + index)?.classList.add('show');

      document.querySelectorAll('.sub-category-wrapper').forEach((el) => {
        el.classList.remove('show');
      });

      const currentSubCategoryWrapper = document.querySelector(
        '#sub-category-' + index,
      ) as HTMLElement;
      if (!currentSubCategoryWrapper) {
        return;
      }

      const currentSubCategoryWrapperBg =
        currentSubCategoryWrapper.querySelector('.bg') as HTMLElement;

      if (currentSubCategoryWrapperBg) {
        const bgImage = this.menuLinks.filter((x) => x.Id === index)[0];

        if (bgImage && bgImage.Image && index !== 80 && index !== 79) {
          const imageUrl =
            this.imgFxDomain
              .replace('{mode}', 'fill.webp')
              .replace('{size}', '1200x1200') +
            'kategori/' +
            bgImage.Image.Url;
          currentSubCategoryWrapper.style.backgroundImage = `url("${imageUrl}")`;
        }

        if (index === 79) {
          currentSubCategoryWrapper.style.backgroundImage = `url("https://event.imgfx.net/fill.webp.gray/size-1200x1200/info/event-uelt.jpg")`;
        }

        if (index === 80) {
          currentSubCategoryWrapper.style.backgroundImage = `url("https://event.imgfx.net/fill.webp.gray/size-1200x1200/info/om-event.no.jpg")`;
        }
      }
      currentSubCategoryWrapper.classList.add('show');
    }
  }

  mainLeave(index: number) {
    if (index > 90) {
      document
        .querySelector('#main-category-' + index)
        ?.classList.remove('show');
      document.querySelectorAll('.sub-category-wrapper').forEach((el) => {
        el.classList.remove('show');
      });
    }
  }

  initScrollTriggers() {
    // if (isPlatformBrowser(this.platformId)) {
    //   if (this.settingsModel) {
    //     const tl = gsap.timeline({ repeat: 0, repeatDelay: 0.5, delay: 0.3 });
    //     tl.from('#nav-menu .link', {
    //       duration: 0.3,
    //       y: -30,
    //       opacity: 0,
    //       ease: 'power1.inOut',
    //       stagger: {
    //         amount: 1.2,
    //       },
    //     });
    //   }
    // }
  }
}
